import { render } from "./StatisticsPortalVisitsCountNameCell.vue?vue&type=template&id=d98c9430&scoped=true&ts=true"
import script from "./StatisticsPortalVisitsCountNameCell.vue?vue&type=script&lang=ts"
export * from "./StatisticsPortalVisitsCountNameCell.vue?vue&type=script&lang=ts"

import "./StatisticsPortalVisitsCountNameCell.vue?vue&type=style&index=0&id=d98c9430&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d98c9430"]])

export default __exports__